import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getActivityDetails } from "@share/store/slices";
import { DetailWrapper } from "./detail-wrapper";
import { UrlUtils, AppDispatch, RootState } from '@share/utils';
import { ISessionKey } from "@share/common-types";
import { useParams, useLocation } from "react-router-dom";
import { DATES_LABEL, QUOTE_LABEL, ROOMS_LABEL, SESSION_KEY_LABEL } from "@share/constants";

import "./style.scss";

export const ActivityDetails: React.FC = () => {

  const dispatch = useDispatch<AppDispatch>();
  const { activity, loading } = useSelector((state: RootState) => state.activityDetailsStore);

  const location = useLocation();
  const value = useMemo(() => UrlUtils.getValues(), [location.search, activity]);
  const { activityCode, activityName } = useParams<{ activityCode?: string; activityName?: string;}>();
  const isStatic = !!activityName && !(value[DATES_LABEL] && value[ROOMS_LABEL]);
  const sessionKey = value[SESSION_KEY_LABEL] as ISessionKey;
  const quote = value[QUOTE_LABEL] as string | undefined;

  useEffect(() => {
  if(activityCode  && activity === null && !loading){
      dispatch(
        getActivityDetails({
          ActivityCode: activityCode,
          sessionKey: sessionKey,
          isStatic: isStatic,
          quote: quote
        })
      );
    }
  }, [activityCode, sessionKey?.value, isStatic, activity, dispatch]);
  return <DetailWrapper  isStatic={isStatic}/>;
};
